import { IUserStore } from './types';

export const getAuthUser = (store: IUserStore) => store.authUser;
export const getSetAuthUser = (store: IUserStore) => store.setAuthUser;